<template>
  <div class="bxp-form bxp-verify-form">
    <img
      class="bxp-verification-image"
      src="https://mark-cdn.bountixp.com/marketing-v2/wp-content/uploads/2019/09/bountiXP-verification-email-sent.gif"
    />
    <h1 class="bxp-verify-form-heading">Almost there.</h1>
    <p>
      <strong>We've sent a verification email to your inbox.</strong>
    </p>
    <p>
      Click the link in the email, or paste <br />the code into the field below.
    </p>

    <div class="bxp-form-fields">
      <v-text-field
        id="verification_code"
        class="bxp-verify-field"
        label="Verification code"
        prepend-inner-icon="fas fa-tag"
        color="secondary"
        :value="fields.verificationCode.value"
        @keyup="updateVerificationCode($event.target.value)"
        @paste="updateVerificationCode($event.target.value)"
        :append-outer-icon="fields.verificationCode.validationIcon"
        :success="fields.verificationCode.valid"
        :error="fields.verificationCode.valid === false"
        :hint="fields.verificationCode.validationMessage"
        :persistent-hint="true"
        :loading="fields.verificationCode.loading"
        v-scroll-to="'#verification_code'"
      />
    </div>

    <p>
      Didn't receive an email yet?<br />
      Check your spam/junk folder.
    </p>

    <p>
      Problems?
      <a class="bxp-secondary-color" href="mailto:contact@bountixp.com"
        >contact@bountixp.com</a
      >
    </p>
  </div>
</template>

<script>
import axios from "axios";
import { formBus } from "@/formBus";

export default {
  computed: {
    fields() {
      return formBus.fields
    }
  },
  methods: {
    async ajaxSubmitVerificationForm() {
      //Verify reCAPTCHA
      const recaptchaResponse = await this.executeRecaptcha();
      if (!recaptchaResponse) {
        return false;
      }
      //Build the data for the server
      const formData = new FormData();
      formData.append("action", "bxp_ajax_submit_verification_form");
      formData.append("recaptcha_response", recaptchaResponse);
      formData.append("nonce", this.ajaxParams.nonce);
      formData.append("email", formBus.fields.email.value);
      formData.append("verification_code", formBus.fields.verificationCode.value);

      //Send to the server
      return axios.post(this.ajaxParams.ajaxurl, formData).then(response => {
        return response
      });
    },
    async updateVerificationCode(val) {
      formBus.fields.verificationCode.loading = true
      val = val.trim()
      formBus.fields.verificationCode.value = val
      this.resetValidation("verificationCode", val)
      if (formBus.fields.timer !== null) {
        clearTimeout(formBus.fields.verificationCode.timer)
      }
      formBus.fields.verificationCode.timer = setTimeout(
        async val => {
          let valid = null
          let message = null
          const response = await this.ajaxSubmitVerificationForm()
          if (response.data.error) {
            valid = false
            message = "We don't recognise this code, try again";
          }
          if (response.data.success) {
            valid = true
            setTimeout(() => {
              if (response.data.redirect) {
                //Redirect to the login page
                window.location = response.data.redirect
              } else {
                //Continue to the next step
                formBus.userData = response.data.user_data
                this.$router.push({
                  name: "almostThere",
                  query: {
                    email: formBus.fields.email.value,
                    code: formBus.fields.verificationCode.value
                  }
                })
              }
            }, 1000)
          }
          this.updateValidation("verificationCode", valid, message)
          formBus.fields.verificationCode.loading = false
        },
        2500,
        val
      );
    }
  },
  created() {
    const code = this.$route.query.code;
    if (code !== undefined) {
      this.updateVerificationCode(code);
    }
    const email = decodeURI(this.$route.query.email);
    if (email !== undefined) {
      formBus.fields.email.value = email;
    }
  }
};
</script>

<style>
.bxp-verify-form {
  text-align: center;
}

.bxp-verify-form .bxp-form-fields {
  margin: auto;
}

.bxp-verification-image {
  max-width: 100px !important;
  margin-bottom: 16px;
}

.bxp-verify-form-heading {
  margin-bottom: 40px;
}

.bxp-short-text {
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
}

.bxp-verify-field {
  margin-bottom: 20px;
}

.bxp-secondary-color {
  color: var(--v-secondary-base);
}
</style>
